import { collection } from '@firebase/firestore'
import { useFirestoreCollectionMutation } from '@react-query-firebase/firestore'
import { useSnackbar } from '@/hooks/common/useSnackbar'
import { db } from 'config/firebase'
import { UseMutationResult } from 'react-query'

interface AddFirestoreDocumentProps {
  collectionName: string
  useMutationResult?: UseMutationResult
}

export const useAddFirestoreDocument = ({ collectionName, useMutationResult }: AddFirestoreDocumentProps) => {
    const { showSuccess, showError, showInfo, showSnackbar, showWarning } = useSnackbar()

  return useFirestoreCollectionMutation(collection(db, collectionName), {
    ...useMutationResult,
    onError: error => {
      showError(`Adding document to ${collectionName} failed`)
      console.error(error)
    },
  })
}
